<template>
    <transition :enter-active-class="'animated fadeIn'" :leave-active-class="'animated fadeOut'">
        <div class="pop-up-box" v-if="value" @click.stop="outsideClick($event)">
            <div class="container">
                <span class="close-btn" v-if="showClose" @click.stop="closeView"></span>
                <slot name="content"></slot>
                <slot></slot>
            </div>
        </div>
    </transition>

</template>

<script>
export default {
    name: 'PopUpBox',
    props: {
        value: {
            type: Boolean,
            default: true,
        },
        showClose: {
            type: Boolean,
            default: false,
        }
    },
    data() {
        return {};
    },
    methods: {
        // show==false:关闭
        closeView(show = false) {
            this.$emit('input', show);
        },
        outsideClick(e) {
            let event = e || window.event;
            let target = event.target || event.srcElement;
            let domArr = document.getElementsByClassName('pop-up-box');
            for (let index in domArr) {
                if (target == domArr[index]) {
                    this.closeView()
                }
            }
        }
    }
}
</script>
<style lang="less" scoped>
</style>




// WEBPACK FOOTER //
// src/components/PopUpBox.vue